import * as React from "react";
import Glyphicon from "source/app/presentation/Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";

export function LockedNodeIcon({ node }: { node: IWorkflowNode }) {
    if (!node.is_encrypted) {
        return null;
    }

    return (
        <span
            className={StyleClassAuto({
                marginLeft: "8px",
                opacity: 0.6,
            })}
        >
            <Glyphicon icon={EGlyphicon.lock} />
        </span>
    );
}
